// extracted by mini-css-extract-plugin
export default {"heading":"commonCards_heading__OJKUm","aboutimg":"commonCards_aboutimg__mjLO5","title":"commonCards_title__JN9Lo","desc":"commonCards_desc__U+dlf"};